import { MprcReorderList, MprcRequestErrorReport, MprcRequestIndicator, MprcSpinnerIndicator, ReorderListItem } from 'components';
import { ButtonCancel, ButtonSave } from 'components/buttons';
import { MprcSimpleDialog } from 'components/MprcSimpleDialog';
import LibUtils from 'lib/LibUtils';
import { enqueueSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    devPlanId: string;
    onClose: (success?: boolean) => void;
    subtitle?: string;
}

////////////////////////////////////////////////////////////////////////////

export const DevPlanReorderGroupsDialog: React.FC<IProps> = ({ devPlanId, onClose, subtitle }) => {

    const api = useCoreApi();
    const { t } = useTranslation("lms");

    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [groupsInOrder, setGroupsInOrder] = useState<ReorderListItem[]>([]);
    const [viewError, setViewError] = useState<any>();

    const previousGroupsData = useRef<ReorderListItem[]>([]);

    const canSave = !loading && !saving && !LibUtils.deepCompare(previousGroupsData.current, groupsInOrder);

    useEffect(() => {
        setLoading(true);
        api.v1.devPlan.devPlanGroups({ devPlanId })
            .then(response => {
                var items = response.data.map(p => ({ id: p.devPlanGroupId, text: p.name }));

                previousGroupsData.current = items;
                setGroupsInOrder(items);
            })
            .catch(e => setViewError(e))
            .finally(() => setLoading(false));
    }, []);

    ///
    const handleSave = () => {
        setSaving(true);
        api.v1.devPlan.reorderGroups({ devplanId: devPlanId, groupsInOrder: groupsInOrder.map(p => p.id) })
            .then(response => {
                if (response.data === true) {
                    enqueueSnackbar(t("Record.SaveSuccessMessage", { ns: "shared" }), { variant: "success" });
                    onClose(true);
                }
                else {
                    enqueueSnackbar(t("Record.FailSuccessMessage", { ns: "shared" }), { variant: "error" });
                }
            })
            .catch(e => setViewError(e))
            .finally(() => setSaving(false));
    };


    return (
        <MprcSimpleDialog
            title={t("DevPlan.DevPlanGroupsReorderDialog.Title")}
            subtitle={subtitle}
            width="sm"
            message={
                <>
                    {viewError ?
                        <MprcRequestErrorReport error={viewError} />
                        :
                        <>
                            <MprcRequestIndicator type="post" visible={saving} />
                            {loading
                                ? <MprcSpinnerIndicator />
                                : <MprcReorderList
                                    items={groupsInOrder}
                                    onChangeOrder={(items) => setGroupsInOrder(items)}
                                />
                            }
                        </>
                    }
                </>
            }
            onClose={onClose}
            actionsPosition="end"
            actions={
                <>
                    <ButtonCancel onClick={() => onClose()} />
                    <ButtonSave disabled={!canSave} onClick={handleSave} />
                </>
            }
        />
    );
};
